import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig, QueryConfig } from '@/lib/react-query';

import { CalendarUsers, UserResponse } from '@/features/Calendar/types';

export type UserDTO = {
  id?: number;
  filterType?: string;
  page?: number;
  perPage?: number;
};
export const getCalenderUsers = ({
  id,
  filterType,
  page,
  perPage,
}: UserDTO): Promise<UserResponse> => {
  return axios.get(`/business/users/all`, {
    params: { showUsers: filterType, page, perPage },
  });
};
type QueryFnType = typeof getCalenderUsers;
export const useCalenderUsers = ({ id, filterType, page, perPage }: UserDTO) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['calendar-users-availability'],
    queryFn: () => getCalenderUsers({ id, filterType, page, perPage }),
  });
};
